<template>
    <div class="left-side m-n" v-if="!empty">
		<div class="page-header m-t-n m-b-xs p-b-xs">
			<h1 class="m-n text-u-c">Events</h1>
      <div class="viewAll" v-if="views" @click="viewAll()">view all</div>
		</div>

    <div style="width: 100%;" v-for="event in events" :key="event.event_id">
      <section class="panel panel-default m-b item_child event-b">
        <a @click="goEvent(event.id)" class="block item_url b-b b-light">
          <span v-if="event.privacy" class="text-black">
            <div class="item-privacy"> <i class="fa fa-lock text-muted"></i></div>
          </span>
          <div class="image_block">
            <lazy-img-loader
              :mainImg="event.avatar"
              :fallbackImg="'https://ukuyacommunity.s3.amazonaws.com/system/event_default.jpg'"
              :imgAlt="event.title"
              :imgClass="'item_avatar'"
            ></lazy-img-loader>
          </div>
        </a>
        <span class="event-item-status">
      <span v-if="getStatus(event) == 'upcoming'" class="label label-info pull-right m-t-n-sm text-u-c no-radius wrapper-xs" style="position: relative;">UPCOMING</span>
      <span v-if="getStatus(event) == 'thisweek'" class="label label-primary pull-right m-t-n-sm text-u-c no-radius wrapper-xs" style="position: relative;">THIS WEEK</span>
      <span v-if="getStatus(event) == 'ongoing'" class="label label-success pull-right m-t-n-sm text-u-c no-radius wrapper-xs" style="position: relative;">ONGOING</span>
      <span v-if="getStatus(event) == 'ended'" class="label label-danger pull-right m-t-n-sm text-u-c no-radius wrapper-xs" style="position: relative;">ENDED</span>
        </span>
        <div @click="goEvent(event.id)" class="e-title">
          {{event.title}}
        </div>

        <footer @click="goEvent(event.id)" class="panel-footer bg-light lter">
          <div class="row no-padder">
            <div class="col-xs-10">
          <span class="block text-xs text-muted">
            <span class="text-muted m-r-xxs"><i class="fa fa-clock-o "></i></span>
            <span class="text-u-c item_started">{{event.start_time | moment("DD MMM YYYY hh:mm A")}}</span>
          </span>
              <span class="block text-xs text-muted text-ellipsis">
            <span class="m-r-xs"><i class="fa fa-map-marker"></i> </span>
            <span class="item_short_address">
              <span v-if="event.city">{{event.city.name}}</span>
              <span v-if="event.country">  {{event.country.name}}</span>
            </span>
          </span>
            </div>
          </div>
        </footer>
      </section>
    </div>
    <div v-if="loader">
      <pre-loader></pre-loader>
    </div>
    </div>
</template>

<script>
  import moment from 'moment-timezone';
  import shave from 'shave';
  import ApiService from "../../../../services/ApiService";
  import LazyImgLoader from '@src/components/lazy-img-loader'

export default {
  components: {
    LazyImgLoader
  },
  data() {
    return {
      loader: false,
      apiService: new ApiService(),
      isOwner: false,
      empty: false,
      views: false,
      events: null,
      perPage: 3,
      page: 1
    }
  },
  created() {
    this.getEvents(this.profile.profile_id);
    window.scrollTo(0, 0);
  },
  computed: {
    profile() {
      return this.$store.getters.profile;
    }
  },
  mounted() {
  },
  methods: {
    goOwner(id) {
      this.$router.push(`../${id}`);
      window.scrollTo(0);
    },
    goEvent(target) {
      window.location.assign(`${window.user.community_url}/${window.user.community_domain}/default/events/view/${target}`)
    },
    getEvents(profile_id = null) {
      this.loader = true;
      if(profile_id) {
        this.apiService.get(`/event?community_id=${window.user.community_id}&profile_id=${profile_id}&page=${this.page}&per-page=${this.perPage}&expand=owner,city,country`)
          .then(res => {
            res.items.map(e => {
              e.avatar = this.addAWS(e.avatar);
            });
            this.empty = res._meta.totalCount === 0;
            if(this.empty) this.getEvents();
            this.events = res.items;
            this.views = res._meta.pageCount > res._meta.currentPage;
            this.loader = false;
            setTimeout(() => {
              shave('.e-title', 50, {character: '...'});
            }, 200);
          })
      } else {
        this.apiService.get(`/event?community_id=${window.user.community_id}&page=${this.page}&per-page=${this.perPage}&expand=owner,city,country`)
          .then(res => {
            res.items.map(e => {
              e.avatar = this.addAWS(e.avatar);
            });
            this.empty = res._meta.totalCount == 0;
            this.events = res.items;
            this.views = res._meta.pageCount > res._meta.currentPage;
            this.loader = false;
            setTimeout(() => {
              shave('.e-title', 50, {character: '...'});
            }, 200);
          })
      }

    },
    addAWS(url) {
      if (!/^(f|ht)tps?:\/\//i.test(url)) {
        url =  process.env.AWS_URL + "/" + url;
      }
      return url;
    },
    getStatus(event) {
      const now = moment.now();
      const begin = event.start_time * 1000;
      const end = event.end_time * 1000;

      if (moment(now).isAfter(moment(begin)) && moment(now).isBefore(moment(end))){
        status = 'ongoing';
      } else if (moment(now).isAfter(moment(begin).subtract(7, 'days')) && moment(now).isBefore(moment(end))) {
        status = 'thisweek';
      } else if (moment(now).isBefore(moment(begin).subtract(7, 'days'))) {
        status = 'upcoming';
      } else {
        status = 'ended';
      }
      return status;
    },
    viewAll() {
      this.$router.push('events');
    }
  }
}
</script>
<style lang="scss" scoped>
  .lazy-image-placeholder {
    background-position: center center;
    background-repeat: no-repeat;
    background-size: auto;
  }
  .lazy-img, .lazy-image-main {
    width: 100%;
  }
  .loader {
    width: 200px;
    height: 100px;
    left: calc(50% - 100px);
  }
  h2 {
    line-height: 60%;
  }
  .left-side .page-header {
    padding-bottom: 15px !important;
  }
  .left-side {
    max-width: 222px;

  }
  .page-header {
    margin-top: 17px;
    margin-bottom: 0;
    color: #000;
  }
  .page-header h1 {
    font-style: normal;
    font-weight: 300 !important;
    font-size: 20px;
    line-height: 23px;
    letter-spacing: 0.72px;
  }
  .e-title {
    font-weight: normal;
    font-size: 16px;
    line-height: 19px;
    color: #333333;
    cursor: pointer;
    padding: 7px;
    box-sizing: border-box;
    padding-top: 0;
  }
  .e-owner {
    font-weight: normal;
    font-size: 13px;
    line-height: 15px;
    padding-left: 7px;
    padding-top: 5px;
    color: #000000;
    cursor: pointer;
    display: block;
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .image_block {
    height: 135px;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
  }
  .item-privacy {
    position: absolute;
    margin-top: 5px;
    margin-left: 10px;
  }
  .event-b {
    &:hover{
      box-shadow: 0 5px 10px rgba(0,0,0,.1) !important;
    }
  }
  @media only screen and (max-width: 767px) {
    .left-side {
      max-width: 100%;
    }
    .image_block {
      width: 100%;
      height: 184px;
      display: flex;
      align-items: center;
    }
    .e-title {
      font-size: 15px;
    }
    .e-owner {
      font-size: 12px;
    }
  }
</style>

<style lang="scss">
  .item_avatar {
    width: 100% !important;
    height: 100% !important;
  }
</style>